import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ToastContainer, toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { ChromePicker } from 'react-color';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../../elementos/iconos/IconosGenerales";
import { FormControlLabel, Switch } from '@mui/material';

import { handleChangeErrors, handleSubmitErrorsEmpresas, todosDatosCorrectos } from '../../validacion/ValidationFormEmpresa';
import { fetchEditarEmpresaColaboradora, fetchEmpresaColaboradoraData } from '../../../peticiones_API/PeticionesEmpresasColaboradoras';
import { DatosCorrectosEmpresa, ServerNoCreoEmpresa, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import ErrorForm from '../eventos/avisos/Alerta';

const FormEditarEmpresaColaboradora = () => {
    const { Id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL;
    const [empresaData, setEmpresaData] = useState({ id: Id });
    const [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [errorEnviarForm, setErrorEnviarForm] = useState({ empresaDuplicado: null });
    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);
    const [mostrarColorPicker, setMostrarColorPicker] = useState(false);

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        color: "Debes seleccionar un color"
    };
    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        color: null
    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleChange = (event) => {

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const { name, value, type, files } = event.target;
        let newValue = type === 'file' ? files[0] : value;
        setEmpresaData(prev => ({ ...prev, [name]: newValue }));

        if (type === 'file' && files[0] && name === 'logoEmpresa_img') {
            const reader = new FileReader();
            reader.onloadend = () => setPrevisualizacionImg(reader.result);
            reader.readAsDataURL(files[0]);
        }

        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
    };

    const handleColorChange = (color) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        
        setEmpresaData(prev => ({ ...prev, color: color.hex }));
        handleChangeErrors('color', color.hex, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
    };

    const handleDelete = () => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        setPrevisualizacionImg(null);
        document.getElementById("logoEmpresa_img").value = "";
        delete empresaData.logo;
        setEmpresaData(prevData => ({ ...prevData, logo: null, imagen_base64: null }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        handleSubmitErrorsEmpresas(empresaData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
        setEstadosActualizados(true);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const empresa = await fetchEmpresaColaboradoraData(Id);
                setEmpresaData(empresa);
                if (empresa.logo) {
                    const urlPrevisualizacion = `/api/empresa-colaboradora/logo/${empresa.logo}?t=${Date.now()}`;
                    setPrevisualizacionImg(`${API_URL}${urlPrevisualizacion}` || null);
                }
            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        };
        fetchData();
    }, [Id]);

    useEffect(() => {
        const imgInput = document.getElementById("logoEmpresa_img");
        const valorImg = imgInput ? imgInput.value : "";

        if ((empresaData.logo == null || empresaData.logo == "") && (valorImg != "")) {
            const logo = `${Id}_empresacolab_img`;
            setEmpresaData(prevFormData => ({ ...prevFormData, logo: logo }));
        }

        if (estadosActualizados) {
            const validacionTodosDatos = todosDatosCorrectos(empresaData, estadoCampoReque);
            const todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    setErrorEnviarForm({ empresaDuplicado: false });
                    try {
                        const formData = new FormData();
                        formData.append('Id', empresaData.Id);
                        formData.append('nombre', empresaData.nombre);
                        formData.append('color', empresaData.color);
                        formData.append('vacaciones', empresaData.vacaciones || false);

                        if (empresaData.logoEmpresa_img)
                            formData.append('logoEmpresa_img', empresaData.logoEmpresa_img);
                        else if (empresaData.logo == null)
                            formData.append('logoEmpresa_img', "");

                        await fetchEditarEmpresaColaboradora(formData);
                    } catch (error) {
                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm({ empresaDuplicado: true });
                        }
                        setFormCompletado(false);
                    }
                } else {
                    toast.error("Faltan campos por rellenar");
                }
            })();
        }
    }, [estadosActualizados, empresaData, estadoCampoReque]);

    return (
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="EDITAR EMPRESA COLABORADORA" />
                </CabeceraForm>
                <Container>
                    <ToastContainer />
                    <TituloSeccion className='mb-12'>INFORMACION GENERAL</TituloSeccion>
                    <Row md="3" className="align-items-end mb-3">
                        <Form.Group className="mb-12">
                            <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                            <Form.Control
                                type="text"
                                name="nombre"
                                className="py-3"
                                value={empresaData.nombre || ''}
                                onChange={handleChange}
                            />
                            <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                        </Form.Group>

                        <Form.Group className="mb-12">
                            <TituloCategoria>Color <span>*</span></TituloCategoria>
                            <div style={{ position: 'relative' }}>
                                <div
                                    style={{
                                        padding: '11px',
                                        background: '#fff',
                                        borderRadius: '4px',
                                        border: '1px solid #ced4da',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}
                                    onClick={() => setMostrarColorPicker(!mostrarColorPicker)}
                                >
                                    <div style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '4px',
                                        background: empresaData.color || '#ffffff',
                                        border: '1px solid #ccc'
                                    }} />
                                    <span>{empresaData.color || 'Seleccionar color'}</span>
                                </div>
                                {mostrarColorPicker && (
                                    <div style={{ position: 'absolute', zIndex: 2, marginTop: '5px' }}>
                                        <div
                                            style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }}
                                            onClick={() => setMostrarColorPicker(false)}
                                        />
                                        <ChromePicker
                                            color={empresaData.color || '#ffffff'}
                                            onChange={handleColorChange}
                                        />
                                    </div>
                                )}
                            </div>
                            <ErrorForm mensaje={camposRequeridos.color} estadoAlerta={estadoCampoReque.color} />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={empresaData.vacaciones || false}
                                        onChange={(e) => setEmpresaData(prev => ({ ...prev, vacaciones: e.target.checked }))}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'rgba(0, 60, 102, 0.5)' }
                                        }}
                                    />
                                }
                                label={<span style={{ fontSize: '15.6px', fontWeight: 'bold', fontFamily: 'Open Sans', color: '#4a4a4a' }}>Vacaciones</span>}
                            />
                            <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '-4px', marginLeft: '12px' }}>
                                Las personas de esta empresa tendrán acceso a la sección de vacaciones
                            </div>
                        </Form.Group>
                    </Row>

                    <TituloSeccion className='mb-12'>LOGO DE LA EMPRESA</TituloSeccion>
                    <Row className="mt-4 mb-4">
                        <Col>
                            {previsualizacionImg ? (
                                <div>
                                    <TituloCategoria>Vista previa del logo:</TituloCategoria>
                                    <ContenedorEncabezado>
                                        <IconosGenerales alerta="true" id="delete" onClick={handleDelete} />
                                        <img
                                            src={previsualizacionImg}
                                            onError={() => {
                                                setEmpresaData(prevData => ({ ...prevData, logo: null, imagen_base64: null }));
                                                setPrevisualizacionImg(null);
                                            }}
                                            alt="Vista previa"
                                            style={{
                                                maxWidth: '100%', maxHeight: '250px', minHeight: '200px',
                                                width: 'auto', height: 'auto', objectFit: 'contain',
                                                display: 'block', margin: '0 auto'
                                            }}
                                        />
                                    </ContenedorEncabezado>
                                </div>
                            ) : (
                                <div>
                                    <TituloCategoria>Vista previa del logo:</TituloCategoria>
                                    <img
                                        src={ImagenDefault}
                                        alt="Vista previa"
                                        style={{
                                            maxWidth: '100%', maxHeight: '250px', minHeight: '200px',
                                            width: 'auto', height: 'auto', objectFit: 'contain',
                                            display: 'block', margin: '0 auto'
                                        }}
                                    />
                                </div>
                            )}
                        </Col>
                        <Col>
                            <Form.Group className="mb-3 mt-10">
                                <TituloCategoria>Adjuntar logo de la Empresa</TituloCategoria>
                                <Form.Control
                                    type="file"
                                    id='logoEmpresa_img'
                                    accept=".jpg,.jpeg,.png,.webp"
                                    max-file-size="3072"
                                    name="logoEmpresa_img"
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <ContenedorBotones>

                            <Boton
                                bonificados="true"
                                grande="true"
                                as="button"
                                primario="true"
                                type="submit"
                                onClick={handleSubmit}
                                form="true"
                                name='guardar_cambios_statico'
                            >
                                Guardar
                            </Boton>

                            <Boton
                                bonificados="true"
                                grande="true"
                                as="button"
                                primario="true"
                                type="submit"
                                onClick={handleSubmit}
                                form="true"
                            >
                                Guardar y Salir
                            </Boton>
                            <Boton grande="true" to="/gestionpersonas/empresas">
                                Cancelar
                            </Boton>
                        </ContenedorBotones>
                    </Row>
                </Container>
            </Form>

            {botonRenderClick ? 
                <DatosCorrectosEmpresa envioActivado={formCompletado} />         
                :             
                <DatosCorrectosEmpresa envioActivado={formCompletado} redirect={false} />
            }
    
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.empresaDuplicado} />
            <ServerNoCreoEmpresa envioActivado={errorEnviarForm.empresaDuplicado} editar={true} />
        </>
    );
};

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`;

const ContenedorBotones = styled.div`
    margin-top: 30%;
`;

const ContenedorEncabezado = styled.div`
    width: 446px !important;
    height: auto !important;
    border: 1px solid #dee2e6;
`;

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;
    span {
        color: #ff0000;
        font-weight: 400;
    }
`;

const TituloSeccion = styled.h4`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 15px;
    color: #2c3e50;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 8px;
    margin-bottom: 25px;
`;

export default FormEditarEmpresaColaboradora;
